module.exports = __webpack_public_path__ + "static/media/weekly-orders.9f16ad79.png";